import { useEffect, useState } from 'react';

/** Debounces `value` by `delayMs`. Updates immediately when cleared to empty. */
export function useDebouncedValue(value: string, delayMs: number): string {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const isCleared = value.trim() === '';
    const nextValue = isCleared ? '' : value;
    const delay = isCleared ? 0 : delayMs;

    const timeoutId = window.setTimeout(() => {
      setDebouncedValue(nextValue);
    }, delay);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [delayMs, value]);

  return debouncedValue;
}
